export function isValidURL(urlString: string) {
  // Regular expression for a URL with optional protocol and at least one period
  const urlRegex = /^(?:(?:https?|ftp):\/\/)?(?:www\.)?[a-zA-Z0-9-]+(?:\.[a-zA-Z]{2,})+.*$/;

  // Test the URL against the regex
  return urlRegex.test(urlString);
}
export function isValidEmail(email: string) {
  const emailRegex = /^[a-zA-Z0-9._%+-]+(?:[a-zA-Z0-9._%+-])?@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return emailRegex.test(email.trim());
}
/**
 * Regular expression for a URL according to RFC 3986 and additionally checks if it starts with http or https.
 * The regex implementation is based on the FILTER_VALIDATE_URL from PHP, modified to check for http or https at the beginning.
 *
 * @param {string} url
 *
 * @returns {boolean}
 */
export function isValidUrlRFC3986StartsWithHttpOrHttps(url: string): boolean {
  const urlRegex =
    /^(https?):\/\/(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(?::\d{1,5})?(?:\/[a-zA-Z0-9-._~:/?#[\]@!$&'()*+,;=%]*)?$/;

  return urlRegex.test(url);
}
/**
 * Regular expression for an email according to RFC 5322.
 * The regex implementation is based on the FILTER_VALIDATE_EMAIL from PHP.
 *
 * @param {string} email
 *
 * @returns {boolean}
 */
export function isValidEmailRFC5322(email: string): boolean {
  const emailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z]{2,})+$/;

  return emailRegex.test(email.trim());
}
